import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getProductMarkerNormalAsync, getProductMarkerHoverAsync, getVideoMarkerNormalAsync } from '../../utils/StaticAssetManager.js';
import Marker from './Marker.jsx';
import ComposableModal from '../ui/modals/composable/ComposableModal.jsx';
import ImageCarouselModal from '../ui/modals/image-carousel/ImageCarouselModal.jsx';
import HotspotCircle from './ReactSVGHotspots/HotspotCircle';
import HotspotPlus from './ReactSVGHotspots/HotspotPlus';
import { getHotspotIconStyle } from '../../utils/StoreConfigManager.js';
import { getIconSVGAsync } from '../ui/ui-layer-panel/SVGIcons.jsx';
import TextModal from '../ui/modals/text/TextModal';
import { ModalTypes } from '../ui/modals/utils/ModalConstants';
import { AppContext } from '../../AppContext.jsx';
import { ImageCarouselClicked, BookAppointmentClicked } from '../../utils/Analytics.js';
import PopUpTextBox from './PopUpTextBox.jsx';
import PreviewTextBox from './PreviewTextBox.jsx';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';


const isMobile = isMobileDevice();

const womanFurPreviewTextBox = 'https://cdn.obsess-vr.com/fendi/PreviewTextBox/WomanFallWinterFurLookbook.svg';
const womanPreviewTextBox = 'https://cdn.obsess-vr.com/fendi/PreviewTextBox/WomanFallWinterLookbook.svg';
const menPreviewTextBox = 'https://cdn.obsess-vr.com/fendi/PreviewTextBox/MenFallWinterLookbook.svg';
const bookAnAppointmentPreviewTextBox = 'https://cdn.obsess-vr.com/fendi/PreviewTextBox/BookAnAppointment.svg';

const womanFurPopUpTextBox = `https://cdn.obsess-vr.com/fendi/PopUpTextBox/WomanFurLookbook${isMobile ? 'Mobile' : 'Desktop'}.svg`;
const womanPopUpTextBox = `https://cdn.obsess-vr.com/fendi/PopUpTextBox/WomanLookbook${isMobile ? 'Mobile' : 'Desktop'}.svg`;
const menPopUpTextBox = `https://cdn.obsess-vr.com/fendi/PopUpTextBox/MenLookbook${isMobile ? 'Mobile' : 'Desktop'}.svg`;
const bookAnAppointmentPopUpTextBox = `https://cdn.obsess-vr.com/fendi/PopUpTextBox/BookAnAppointment${isMobile ? 'Mobile' : 'Desktop'}.svg`;

const womanFurView13Hotspot = '60f0d2f8c584ff71d102cc1a';
const womanFurView13BackHotspot = '61003664d4c173fde954d61e';
const womanView15Hotspot = '60f5f928f2e43cc4d45f7701';
const womanView15BackHotspot = '6100483dd4c173fde954d64b';
const womanView16Hotspot = '60f0cd06f2e43cc4d45f73fc';
const womanView17Hotspot = '60f5fc83f2e43cc4d45f7703';
const womanView18Hotspot = '60f6034cc584ff71d102cea0';
const menView25Hotspot = '60f608d4f2e43cc4d45f7705';
const menView26Hotspot = '60f0d651f2e43cc4d45f7413';
const menView27Hotspot = '60f60fabf2e43cc4d45f7708';
const bookAnAppointmentView28Hotspot = '60f0c06fc584ff71d102cbb8';
const bookAnAppointmentView29Hotspot = '60f0c0edc584ff71d102cbbe';

const previewHotspots = [womanFurView13Hotspot, womanFurView13BackHotspot,
                        womanView15Hotspot, womanView15BackHotspot, womanView16Hotspot, womanView17Hotspot, womanView18Hotspot,
                        menView25Hotspot, menView26Hotspot, menView27Hotspot,
                        bookAnAppointmentView28Hotspot, bookAnAppointmentView29Hotspot]

const popUpHotspots = [womanFurView13Hotspot, womanFurView13BackHotspot,
                        womanView15Hotspot, womanView15BackHotspot, womanView16Hotspot, womanView17Hotspot, womanView18Hotspot,
                        menView25Hotspot, menView26Hotspot, menView27Hotspot,
                        bookAnAppointmentView28Hotspot, bookAnAppointmentView29Hotspot]


const bookAnAppointmentHotspot = "60d24a5ac584ff71d1028c11";
export const ModalMarkerTypes = Object.freeze({
    Image: "image",
    Video: "video",
    ImageCarousel: 'image_carousel',
    TextWithButton: 'text_with_button'
});

export const MarkerImageAssets = Object.freeze({
    VideoMarker: "https://cdn.obsess-vr.com/play-icon.svg",
    ImageMarker: "https://cdn.obsess-vr.com/fendi/contentHotspotIcon.svg",
    TextMarker: "https://cdn.obsess-vr.com/fendi/infoHotspotIcon.svg",
    BookAnAppointmentHotspotMarker: "https://cdn.obsess-vr.com/fendi/contentHotspotIcon.svg"
});

class ModalMarker extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.hide = this.hide.bind(this);
        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);
        this.generatePreviewTextBoxFromSVG = this.generatePreviewTextBoxFromSVG.bind(this)
        this.generatePopUpTextBoxFromSVG = this.generatePopUpTextBoxFromSVG.bind(this)

        this.state = {
            isShowingModal: false,
            normalSpriteUrl: '',
            hoverSpriteUrl: '',
            svgSprite: null,
            svgSpriteString: '',
            showPreviewTextBox: false,
            previewTextBoxSpriteUrl: '',
            showPopUpTextBox: false,
            popUptextBoxSpriteUrl: ''
        };
        this.mounted = false;
        this.timeOutFunction = null;

        switch (props.type) {
            case ModalMarkerTypes.Video:
                this.setSVGIcon(MarkerImageAssets.VideoMarker);
                break;
            case ModalMarkerTypes.Image:
                // TODO: import web-store-modules for svgs.
                this.setSVGIcon(MarkerImageAssets.ImageMarker);
                break;
            case ModalMarkerTypes.ImageCarousel:
                // TODO: import web-store-modules for svgs.
                this.setSVGIcon(MarkerImageAssets.ImageMarker);
                break;
            case ModalMarkerTypes.TextWithButton:
                if (props.hotspotId['$oid'] == bookAnAppointmentHotspot) {
                    this.setSVGIcon(MarkerImageAssets.BookAnAppointmentHotspotMarker);
                }
                else {
                    this.setSVGIcon(MarkerImageAssets.TextMarker);
                }
                break;
            default:
                getProductMarkerNormalAsync()
                    .then(url => this.setState({ normalSpriteUrl: url }))
                    .catch(error => console.error(error));
                getProductMarkerHoverAsync()
                    .then(url => this.setState({ hoverSpriteUrl: url }))
                    .catch(error => console.error(error));
                getHotspotIconStyle()
                    .then(icon => {
                        const Sprite = icon == 'blank' ? HotspotCircle : HotspotPlus;
                        this.setState({ svgSprite: Sprite });
                    })
                    .catch(error => console.error(error));
                break;
        }
    }

    setSVGIcon(markerIconUrl) {
        getIconSVGAsync(null, markerIconUrl)
            .then(svgString => this.setState({ svgSpriteString: svgString }))
            .catch(error => console.error(error));
    }

    componentDidMount() {
        this.mounted = true;
        this.generatePopUpTextBoxFromSVG()
    }

    componentWillUnmount() {
        this.mounted = false;
        clearTimeout(this.timeOutFunction);
    }

    generatePreviewTextBoxFromSVG() {
        if([womanFurView13Hotspot, womanFurView13BackHotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ previewTextBoxSpriteUrl: womanFurPreviewTextBox })
            this.setState({ showPreviewTextBox: true })
        }
        if([womanView15Hotspot, womanView15BackHotspot, womanView16Hotspot, womanView17Hotspot, womanView18Hotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ previewTextBoxSpriteUrl: womanPreviewTextBox })
            this.setState({ showPreviewTextBox: true })
        }
        if([menView25Hotspot, menView26Hotspot, menView27Hotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ previewTextBoxSpriteUrl: menPreviewTextBox })
            this.setState({ showPreviewTextBox: true })
        }
        if([bookAnAppointmentView28Hotspot, bookAnAppointmentView29Hotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ previewTextBoxSpriteUrl: bookAnAppointmentPreviewTextBox })
            this.setState({ showPreviewTextBox: true })
        }
    }

    generatePopUpTextBoxFromSVG() {
        if([womanFurView13Hotspot, womanFurView13BackHotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ popUptextBoxSpriteUrl: womanFurPopUpTextBox })
            this.setState({ showPopUpTextBox: true })
        }
        if([womanView15Hotspot, womanView15BackHotspot, womanView16Hotspot, womanView17Hotspot, womanView18Hotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ popUptextBoxSpriteUrl: womanPopUpTextBox })
            this.setState({ showPopUpTextBox: true })
        }
        if([menView25Hotspot, menView26Hotspot, menView27Hotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ popUptextBoxSpriteUrl: menPopUpTextBox })
            this.setState({ showPopUpTextBox: true })
        }
        if([bookAnAppointmentView28Hotspot, bookAnAppointmentView29Hotspot].includes(this.props.hotspotId['$oid'])) {
            this.setState({ popUptextBoxSpriteUrl: bookAnAppointmentPopUpTextBox })
            this.setState({ showPopUpTextBox: true })
        }
    }

    onClick() {
        if (!this.mounted) {
            return;
        }
        this.setState({ isShowingModal: true });
        this.setState({ showPreviewTextBox: false });
        this.setState({ showPopUpTextBox: false })
    }

    onHover() {
        this.generatePreviewTextBoxFromSVG();
        this.setState({ showPopUpTextBox: false })
    }

    onUnhover() {
        this.setState({ showPreviewTextBox: false });
    }

    hide() {
        this.setState({ showPopUpTextBox: false });
    }

    onModalHidden() {
        if (!this.mounted) {
            return;
        }
        this.setState({ isShowingModal: false });
    }

    getTextModal() {
        if (this.props.modalContent && typeof this.props.modalContent.button_copy != 'undefined' && this.props.modalContent.button_copy.toLowerCase().includes('appointment')) {
            const title = this.props?.modalContent?.title;
            const currentSceneName = this.props?.currentSceneName;
            BookAppointmentClicked(title, currentSceneName);
        }
        return (
            <TextModal
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
                hotspotId={this.props.hotspotId}
            />
        );
    }

    getComposableModal() {
        return (
            <ComposableModal
                type={this.props.type}
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
            />
        );
    }

    getImageCarouselModal() {
        ImageCarouselClicked(this.props?.modalContent?.pages[0]?.title, this.props.currentSceneName);
        return (
            <ImageCarouselModal
                modalContent={this.props.modalContent}
                onModalHidden={this.onModalHidden}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
                hotspotId={this.props.hotspotId}
            />
        );
    }

    renderModal() {
        if (this.state.isShowingModal && this.props.type) {
            switch (this.props.type) {
                case ModalTypes.TextModal:
                    return this.getTextModal();
                case ModalTypes.ImageCarousel:
                    return this.getImageCarouselModal();
                default:
                    return this.getComposableModal();
            }
        }
        return null;
    }

    render() {
        const { normalSpriteUrl, hoverSpriteUrl, svgSprite, svgSpriteString } = this.state;

        if (!this.timeOutFunction) {
            if (isMobile) {
                window.addEventListener('touchend', this.hide);
            } else {
                window.addEventListener('click', this.hide);
            }
            this.timeOutFunction = setTimeout(() => {
                this.hide();
            }, 3500);
        }

        return (
            <div>
                {this.renderModal()}
                {previewHotspots.includes(this.props.hotspotId['$oid']) && <PreviewTextBox
                    transform={this.props.transform}
                    colliderTransform={this.props.colliderTransform}
                    hoveredSpriteUrl={this.state.previewTextBoxSpriteUrl}
                    showPreviewTextBox={this.state.showPreviewTextBox}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                    hotspotId={this.props.hotspotId['$oid']}
                />}
                {popUpHotspots.includes(this.props.hotspotId['$oid']) && <PopUpTextBox
                    transform={this.props.transform}
                    colliderTransform={this.props.colliderTransform}
                    hoveredSpriteUrl={this.state.popUptextBoxSpriteUrl}
                    showPopUpTextBox={this.state.showPopUpTextBox}
                    primaryColor={this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                    hotspotId={this.props.hotspotId['$oid']}
                />}
                <Marker
                    transform={this.props.transform}
                    colliderTransform={this.props.colliderTransform}
                    normalSpriteUrl={normalSpriteUrl}
                    hoverSpriteUrl={hoverSpriteUrl}
                    svgSprite={svgSprite}
                    type={this.props.type}
                    svgSpriteString={svgSpriteString}
                    showVisual={this.props.showVisual}
                    onClick={this.onClick}
                    onHover={this.onHover}
                    onUnhover={this.onUnhover}
                    primaryColor={this.props.type == ModalMarkerTypes.Video ? '#FFFFFF' : this.props.primaryColor}
                    secondaryColor={this.props.secondaryColor}
                    fade={this.props.type == ModalMarkerTypes.Video ? true : false}
                />
            </div>
        );
    }
}

ModalMarker.propTypes = {
    transform: PropTypes.array.isRequired,
    colliderTransform: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    modalContent: PropTypes.object.isRequired,
    showVisual: PropTypes.bool,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string
};



export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ModalMarker {...props} currentSceneName={appContextValue.currentSceneName} />
        )}
    </AppContext.Consumer>
);